import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@postcheesy/ui-lib/molecules";
import React from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { PhoneForm } from "../../components/sections/forms/phone";
import { LogoutButton } from "../../components/ui/LogoutButton";

export const VerifyPhone: React.FC = () => {
  
  return (
    <Layout>
      <Container className="py-6">
        <div className="relative mx-auto grid h-full w-fit grid-cols-1 items-start justify-center">
          <section className="lg:my-18 container mx-auto my-12 h-fit max-w-xl py-8 md:my-12 2xl:my-32">
            <LogoutButton variant="link">
              {"< Retouner à la page de connexion"}
            </LogoutButton>
            <Card className="w-full">
              <CardHeader>
                <CardTitle className="text-2xl">Vérification de votre numéro de téléphone</CardTitle>
                <CardDescription className="w-fit text-pretty">
                  Vous devez vérifier votre numéro de téléphone pour continuer
                </CardDescription>
              </CardHeader>
              <CardContent>
                <PhoneForm />
              </CardContent>
            </Card>
          </section>
        </div>
      </Container>
    </Layout>
  );
}
